module.exports = __webpack_public_path__ + "img/no_plato.070382af.png";